<app-jwt-loader>
  <ng-template>
    <router-outlet></router-outlet>
  </ng-template>
</app-jwt-loader>
